// Focus after rendering so phone previews can reveal the editor first.
export function focusDirectorField(container, field) {
  const wrapper = [...(container?.querySelectorAll("[data-field]") || [])].find(node => node.dataset.field === field);
  const control = wrapper?.querySelector('input, textarea, [role="combobox"]');
  const details = control?.closest("details");
  if (details) details.open = true;
  control?.focus();
  control?.scrollIntoView?.({ block: "center", behavior: "instant" });
}

export function informationValidation(information, publish) {
  const invalid = (field, message) => ({ field, message });
  const contact = information.organizerContact || {};
  if (contact.email?.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email.trim())) return invalid("organizerContact.email", "Enter a valid organizer email.");
  if (contact.phone?.trim() && !/^[+\d\s().-]{3,40}$/.test(contact.phone.trim())) return invalid("organizerContact.phone", "Enter a valid organizer phone number.");
  if (contact.website?.trim()) { try { const url = new URL(contact.website.trim()); if (!["http:", "https:"].includes(url.protocol) || url.username || url.password) throw Error(); } catch { return invalid("organizerContact.website", "Use an http or https organizer website."); } }

  if (publish && information.schedule.length && !information.timeZone) return invalid("timeZone", "Choose the match’s time zone before publishing the schedule.");
  if (information.timeZone) {
    try { new Intl.DateTimeFormat("en", { timeZone: information.timeZone }).format(); }
    catch { return invalid("timeZone", "Choose a valid match time zone."); }
  }
  for (const [index, item] of information.schedule.entries()) {
    const field = `schedule.${item.id}`;
    if (publish && !item.title.trim()) return invalid(`${field}.title`, `Add an activity for schedule item ${index + 1}.`);
    if (publish || item.date) {
      const date = new Date(`${item.date}T12:00:00Z`);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(item.date) || !Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== item.date) return invalid(`${field}.date`, `Choose a valid date for schedule item ${index + 1}.`);
    }
    if ((publish || item.time) && !/^([01]\d|2[0-3]):[0-5]\d$/.test(item.time)) return invalid(`${field}.time`, `Choose a time for schedule item ${index + 1}.`);
  }
  for (const [index, item] of information.arrivalChecklist.entries()) {
    if (publish && !item.title.trim()) return invalid(`arrivalChecklist.${item.id}.title`, `Add a title for checklist item ${index + 1}.`);
  }
  return null;
}
